import styled from "styled-components";

export const ConsoleGroupSalesPageContainer = styled.div`
  max-width: 1000px;
  margin: 5rem auto;

  padding: 0 1rem;
  width: 100%;

  @media (max-width: 850px) {
    margin-top: 2rem;
  }

  hr {
    margin: 3rem 0;

    border-color: ${({ theme }) =>
      theme.mode === "dark"
        ? theme.console.sidebar.borderColor
        : "#5757571a"} !important;
  }
`;
